<template>
  <ul class="list_ul2">
    <li
      class="list-item2"
      v-for="(item, index) in list2"
      data-type="0"
      :key="index"
    >
      <div
        class="list-box"
        :class="{ mask: item.message.mask }"
        :data-id="item.trainplan_id"
        @click="lookTrainplan(item)"
      >
        <div class="block1">
          <img
            class="list-img2"
            :src="
              item.trainplan_img
                ? item.trainplan_img
                : require('@/assets/img/new/basic_train.png')
            "
            :onerror="defaultImg"
            alt
          />
          <div class="list-progress2" v-if="item.timing_push != 1">
            <p :style="{ left: item.finish_progress + '%' }">
              {{ item.finish_progress }}%
            </p>
            <a-progress
              :percent="item.finish_progress"
              strokeColor="#5f98d0"
              :strokeWidth="6"
              :showInfo="false"
            />
          </div>
        </div>
        <div class="block2">
          <p class="title">{{ item.trainplan_name }}</p>
          <p class="time">
            {{ item.valid_start_time }} - {{ item.valid_end_time }}
          </p>
          <p class="lesson_des">
            <span v-if="item.timing_push == 1" style="margin-right: 0.15rem">
              <img
                src="@/assets/img/survey/timer.png"
                style="
                  display: inline-block;
                  margin-top: -0.08rem;
                  width: 0.24rem;
                "
                alt
              />
              <!-- 定时推送 -->
              {{ $t("yearCourse.pushCourse") }}
            </span>
            <span
              v-if="item.include_online_lesson == 1 && item.timing_push != 1"
              style="margin-right: 0.15rem"
            >
              <img
                src="@/assets/img/new/ol.png"
                style="
                  display: inline-block;
                  margin-top: -0.08rem;
                  width: 0.24rem;
                  height: 0.22rem;
                "
                alt
              />
              <!-- 在线 -->
              {{ $t("collect.Online") }}
            </span>
            <span v-if="item.include_face_lesson == 1 && item.timing_push != 1">
              <img
                src="@/assets/img/new/fc.png"
                style="
                  display: inline-block;
                  margin-top: -0.08rem;
                  width: 0.24rem;
                  height: 0.22rem;
                "
                alt
              />
              <!-- 面授 -->
              {{ $t("collect.InClassroom") }}
            </span>
          </p>
        </div>
        <threeState class="threeState" :message="item.message"></threeState>
      </div>
    </li>
  </ul>
</template>

<script>
import threeState from "components/collect2/threeState.vue";
export default {
  props: ["list2"],
  components: { threeState },
  data() {
    return {
      defaultImg:
        'this.src="' + require("@/assets/img/new/basic_train.png") + '"',
    };
  },
  methods: {
    lookTrainplan(item) {
      if (item.timing_push == 1) {
        this.$router.push({
          path: "/main/365historyStudy",
          query: {
            tid: item.trainplan_id,
            rid: item.resources_id,
          },
        });
      } else {
        this.$router.push({
          path: "/main/plan_stage",
          query: {
            tid: item.trainplan_id,
            from: "mustStudy",
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.list_ul2 {
  overflow: hidden;
}

.list-item2 {
  position: relative;
  height: 2.34rem;
  background: #fff;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  margin-bottom: 0.2rem;
}

.list-item2[data-type="0"] {
  transform: translate3d(0, 0, 0);
}

.list-item2[data-type="1"] {
  transform: translate3d(-1.2rem, 0, 0);
}

.list-box {
  height: 100%;
}

.block1 {
  width: 2.8rem;
  height: 2rem;
  position: absolute;
  left: 0.28rem;
  top: 0.3rem;

  .list-img2 {
    width: 2.8rem;
    height: 1.58rem;
    position: absolute;
    left: 0;
    top: 0;
  }

  .list-progress2 {
    position: absolute;
    width: 2.8rem;
    left: 0;
    bottom: 0;
    p {
      position: absolute;
      width: 0.6rem;
      height: 0.35rem;
      line-height: 0.3rem;
      margin-left: -0.3rem;
      color: #005587;
      text-align: center;
      background-image: url("~@/assets/img/new/jdbg.png");
      background-size: 100% 100%;
      font-size: 0.16rem;
      top: -0.3rem;
      z-index: 9;
    }
  }
}

.block2 {
  width: 3rem;
  height: 2rem;
  position: absolute;
  right: 1.12rem;
  top: 0.3rem;
  .title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 0.14rem;
    width: 100%;
    height: 0.4rem;
    line-height: 0.4rem;
    color: #252631;
    font-size: 0.28rem;
    font-weight: bold;
  }
  .time {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 0.32rem;
    line-height: 0.32rem;
    color: #666666;
    font-size: 0.22rem;
  }
  .lesson_des {
    margin-top: 0.4rem;
    color: #7f8384;
    span {
      color: #005689;
      font-size: 0.22rem;
    }
    .step-num {
      display: inline-block;
      width: 0.24rem;
      height: 0.24rem;
      margin-right: 0.08rem;
      margin-top: -0.06rem;
    }
  }
}

.threeState {
  position: absolute;
  top: 0.18rem;
  right: 0.22rem;
  z-index: 999;
}

.list-item2 .delete {
  width: 1.2rem;
  height: 2.34rem;
  background: #ff4949;
  font-size: 0.17rem;
  color: #fff;
  position: absolute;
  top: 0;
  right: -1.2rem;
  .drag_del {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -0.17rem;
    margin-top: -0.34rem;
    width: 0.34rem;
    height: 0.34rem;
  }
  .txt_del {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -0.25rem;
    margin-top: 0.1rem;
    width: 0.5rem;
    height: 0.5rem;
    text-align: center;
  }
}

.list-item2 .mask:after {
  content: "";
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  left: 0px;
  top: 0;
  z-index: 10000;
}
</style>
